export const FOOD_SERVICE_URL = {
	label: 'Заказ еды',
	value: 'https://food.pharmstd.ru',
};
